export const SET_TICKET_LOADING = 'SET_TICKET_LOADING'
export const SET_TICKET = 'SET_TICKET'
export const ADD_TICKET = 'ADD_TICKET'
export const EDIT_TICKET = 'EDIT_TICKET'
export const DELETE_TICKET = 'DELETE_TICKET'